var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrokenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.334 93.519c9.34.626 18.706 1.342 28.046 2.177 5.65.508 11.402 1.045 16.874-.626M22.688 93.519c9.583-1.737 19.58-1.412 29.447-1.069 5.193.19 9.61.382 14.802.592",
    stroke: "#222",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.107 108.939c-.292-21.864-.548-39.552-.84-61.416l11.555-.935c.366 21.552.146 43.145.512 64.698M78.355 68.713h7.354v-14.75h-7.375",
    stroke: "#222",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.367 68.468h-2.209L42.967 47.843l-11.937 9.76a6.584 6.584 0 01-6.127.527c-1.998-.842-3.444-2.658-3.865-4.788l-5.6-28.413a6.485 6.485 0 011.051-4.998c1-1.473 2.577-2.447 4.313-2.736l27.66-4.71a6.57 6.57 0 016.758 3.158l5.548 9.444 55.558-10.575a6.582 6.582 0 015.416 1.368c1.525 1.236 2.393 3.078 2.419 5.05l.132 17.232c.026 3.078-2.104 5.788-5.101 6.472l-13.752 3.13 2.971 15.075 6.022-1.079-8.94 24.177S91.057 66.785 90.11 66.127l5.338-.973-4.155-21.125a6.573 6.573 0 014.996-7.682l14.803-3.394-.026-4.025-52.35 9.944c-2.735.527-5.522-.71-6.942-3.104l-5.6-9.55-16.539 2.815 2.42 12.286 7.493-4.814c2.314-1.5 5.311-1.368 7.52.29L64 54.182h2.156",
    stroke: "#222",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.006 58.022a1.006 1.006 0 100-2.011 1.006 1.006 0 000 2.011zM70.006 66.31a1.006 1.006 0 100-2.012 1.006 1.006 0 000 2.011zM74.226 58.022a1.006 1.006 0 100-2.011 1.006 1.006 0 000 2.011zM74.226 66.31a1.006 1.006 0 100-2.012 1.006 1.006 0 000 2.011z",
    fill: "#222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.902 111.024c.154-.171 2.088-2.755 2.088-2.755l1.54 2.738 3.218-2.43 2.105 3.166 2.43-2.242 1.283 2.739 2.824-2.294 2.875 2.345 1.25-2.362 3.182 2.277",
    stroke: "#222",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenArrow);
export default __webpack_public_path__ + "static/media/broken-arrow.fbeb2456.svg";
export { ForwardRef as ReactComponent };